import { create } from "zustand";

import { solomonMainAppTerms } from "@/content/terms/solomonMainAppTerms";

export const TERMS_DISPLAY_ACCEPTANCE_STORAGE_KEY = "solomon_terms_accepted";

const currentDisplayAcceptance = Object.freeze({
    documentKey: solomonMainAppTerms.documentKey,
    version: solomonMainAppTerms.version,
    contentDigest: solomonMainAppTerms.contentDigest
});

interface TermsState {
    isTermsDisplayAccepted: boolean;
    showTermsModal: boolean;
    acceptTermsForDisplay: () => void;
    openTermsModal: () => void;
    closeTermsModal: () => void;
    checkStoredDisplayAcceptance: () => boolean;
}

export const useTermsStore = create<TermsState>((set) => ({
    isTermsDisplayAccepted: false,
    showTermsModal: false,

    acceptTermsForDisplay: (): void => {
        try {
            localStorage.setItem(TERMS_DISPLAY_ACCEPTANCE_STORAGE_KEY, JSON.stringify(currentDisplayAcceptance));
        } catch {
            // localStorage may be unavailable in some environments
        }
        set({ isTermsDisplayAccepted: true, showTermsModal: false });
    },

    openTermsModal: (): void => {
        set({ showTermsModal: true });
    },

    closeTermsModal: (): void => {
        set({ showTermsModal: false });
    },

    checkStoredDisplayAcceptance: (): boolean => {
        try {
            const stored = localStorage.getItem(TERMS_DISPLAY_ACCEPTANCE_STORAGE_KEY);
            if (stored === null) {
                set({ isTermsDisplayAccepted: false });
                return false;
            }

            const parsed: unknown = JSON.parse(stored);
            const accepted =
                typeof parsed === "object" &&
                parsed !== null &&
                "documentKey" in parsed &&
                parsed.documentKey === currentDisplayAcceptance.documentKey &&
                "version" in parsed &&
                parsed.version === currentDisplayAcceptance.version &&
                "contentDigest" in parsed &&
                parsed.contentDigest === currentDisplayAcceptance.contentDigest;

            if (accepted) {
                set({ isTermsDisplayAccepted: true });
                return true;
            }

            localStorage.removeItem(TERMS_DISPLAY_ACCEPTANCE_STORAGE_KEY);
            set({ isTermsDisplayAccepted: false });
            return false;
        } catch {
            try {
                localStorage.removeItem(TERMS_DISPLAY_ACCEPTANCE_STORAGE_KEY);
            } catch {
                // localStorage may be unavailable
            }
            set({ isTermsDisplayAccepted: false });
            return false;
        }
    }
}));
